export default 'Clear Selection';